import React, { Component } from 'react';
import Button from 'react-bootstrap/lib/Button';
import Link from 'react-router-dom/Link';
import { playStoreLink } from '../../../helpers/serverRenderingUtils';
import { AppStoreButton, PlayStoreButton } from '../AppDownloadButtons';
import OutboundLink from '../OutboundLink';
import Avatar from '../Avatar';
import Footer from '../Footer';
import WaitIndicator from '../WaitIndicator';
import styles from './styles.sass';

export default function CallJoin({
  children,
  doRequireStation,
  isIOS,
  isAndroidChrome,
  openInAppUrl,
  station,
  user,
}) {
  const { callJoinCode, referralCode } = user;
  return (
    <div className={styles.callJoin}>
      <div className={styles.callJoinBackground}>
        <div className={styles.stationOwner}>
          {doRequireStation &&
            (station.creator && station.creator.name ? (
              <div>
                <Avatar
                  size={50}
                  src={station.creator.imageUrl}
                  userId={station.creator.userId}
                />
                <h4>{station.creator.name}</h4>
              </div>
            ) : (
              <WaitIndicator className={styles.callJoinLoading} />
            ))}
          <div className={styles.inviteText}>{children}</div>
        </div>
        {isIOS && (
          <p>
            <AppStoreButton width={215} newWindow />
          </p>
        )}
        {isAndroidChrome && (
          <p>
            <PlayStoreButton
              to={playStoreLink({ callJoinCode, referralCode })}
              newWindow
              width={215}
            />
          </p>
        )}
        {!isIOS && !isAndroidChrome && openInAppCallToAction()}
        {(isIOS || isAndroidChrome) && openInAppCallToAction(openInAppUrl)}
        <p className={styles.learnAboutAnchor}>
          <Link to="/">
            <strong>Learn more about Anchor &gt;</strong>
          </Link>
        </p>
      </div>
      <Footer />
    </div>
  );
}

function openInAppCallToAction(url = 'https://anch.co/get_anchor') {
  return (
    <div>
      <p>
        <small className={styles.openInAppText}>Already have the app?</small>
      </p>
      <OutboundLink to={url} className="visible-xs-inline visible-sm-inline">
        <button className={`cyanButton ${styles.linkButton}`}>
          Open in App
        </button>
      </OutboundLink>
    </div>
  );
}
